module.exports = __webpack_public_path__ + "img/2人（次）高进阶培训班.db70803d.png";